import logo from "./logo.svg";
import "./App.css";
import Header from "./components/header/Header";
import Footer from "./pages/footer/Footer";
import { Route, Routes } from "react-router-dom";
import { routes } from "./routes/routes";
import { Toaster } from "react-hot-toast";
import ScrollToTop from "./pages/scrolltop/ScrollToTop";
import { SidebarProvider } from "./common/Sidecontext";
import FileUpload from "./common/overlay/Loadder";
import { endpoints } from "./api/endpoints";
import Api_Instance from "./api/Api_Instance";
import { useDispatch, useSelector } from "react-redux";
import { setBanner } from "./redux/slice/Slice";
import { useEffect } from "react";

function App() {
  const api = Api_Instance.unAuth();
  const dispatch = useDispatch();
  const bannerId = useSelector((state) => state?.auth?.bannerId)
  const RouteWrapper = ({ element }) => (
    <div className="pt-[40px]">{element}</div>
  );
  const handleChange = async () => {

    try {
      // const resd = await api("GET","http://192.168.100.241:8089/otherLeads/set_language/?lang=hi" )
      const res = await api("GET", endpoints.BUSSINESS_API, null, { category: bannerId[0]?.id });
      dispatch(setBanner(res?.data?.data));

    } catch (error) {
    }
  }

  useEffect(() => {
    handleChange()
  }, [])



  // useEffect(() => {

  //   dispatch({ type: "FETCH" });
  // }, [dispatch]);
  return (
    <>
      <ScrollToTop />
      <FileUpload />
      <SidebarProvider>
        <Header />
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              zIndex: 1100,
            },
          }}
        />
        <Routes>
          {routes.map(({ path, element, wrapper }) => (
            <Route
              key={path}
              path={path}
              element={wrapper ? <RouteWrapper element={element} /> : element}
            />
          ))}
        </Routes>
      </SidebarProvider>
      <Footer />
    </>
  );
}

export default App;
